import { Controller } from "@hotwired/stimulus"

// Submits the controller's own form (the element it's attached to) whenever a
// bound control fires its action — used by the CSV import review rows so the
// "Skip" toggle and category picker apply instantly over Turbo without a
// separate "Save" button. Plain synchronous submit, no timers (per AGENTS §6).
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
